import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from 'app/services/user/user.service';
import { UserDto } from 'app/models/user-dto';
import { loginByAdmin, UserLoginDto } from 'app/models/user-login-dto';
import { AppConfigService } from 'app/services/app-config.service';
import { ImageFallbackDirective } from "app/modules/admin/directives/ImageFallbackDirective";
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { ImageUrlPipe } from 'app/modules/admin/pipe/image-url.pipe';

export interface SelectOption {
  value: string;
  label: string;
  class: string;
}


@Component({
  standalone: true,
  selector: 'app-users',
  imports: [CommonModule, ReactiveFormsModule, FormsModule , NgSelectModule , ImageFallbackDirective,ImageUrlPipe],
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  allUsers: UserDto[] = []; // جميع البيانات
  users: UserDto[] = []; // البيانات المعروضة حالياً
  filteredUsers: UserDto[] = []; // للبحث
  selectedType!: SelectOption ;

  // Pagination properties
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number = 0;
  totalPages: number = 0;
  isLoading: boolean = false;

  userUrl : string = ''
  // للبحث
  searchTerm: string = '';


  editProfileForm!: FormGroup;
showEditProfileModal = false;
isUpdatingProfile = false;
selectedUser: any = null;

  // أنواع المستخدمين
  userTypes = [
    { value: 'customer', label: 'Customer', class: 'customer' },
    { value: 'admin', label: 'Admin', class: 'admin' },
    { value: 'seller', label: 'Seller', class: 'seller' }
  ];
domain: string = "";
  constructor(
    private userService: UserService,
    private router: Router,
    private config : AppConfigService,
    private fb: FormBuilder
  ) {
    this.domain = this.config.SavedURL.replace("/api","");
    this.userUrl = this.config.customerUrl;
    console.log(this.domain);

  }

  ngOnInit() {
    this.selectedType ={ value: 'customer', label: 'Customer', class: 'customer' };
    this.loadAllUsers();
    this.editProfileForm = this.fb.group({
    userId: [0, Validators.required],
    name: [''],
    code: [''],
    phone: [''],
    oldPassword: [''],
    newPassword: ['']
  });
  }
openEditProfileModal(user: any): void {
  this.selectedUser = user;
  this.showEditProfileModal = true;
  this.editProfileForm.patchValue({
    userId: user.id,
    name: user.name || '',
    phone: user.phone || '',
    newPassword: ''
  });

}

closeEditProfileModal(): void {
  this.showEditProfileModal = false;
  this.selectedUser = null;
  this.editProfileForm.reset();
}

submitEditProfile(): void {
  if (this.editProfileForm.invalid) {
    return;
  }

  this.isUpdatingProfile = true;

  this.userService.updateProfile(this.editProfileForm.value).subscribe({
    next: () => {
      this.isUpdatingProfile = false;
      alert('تم تعديل البيانات بنجاح');
      this.closeEditProfileModal();

      // لو عندك دالة تحميل اليوزرز
      this.loadAllUsers();
    },
    error: (err) => {
      this.isUpdatingProfile = false;
      console.error(err);
      alert('حدث خطأ أثناء تعديل البيانات');
    }
  });
}
  // دالة جديدة لجلب جميع البيانات مرة واحدة
  loadAllUsers() {
    this.isLoading = true;
    console.log(this.selectedType);
    this.userService.getUsers(this.selectedType.value).subscribe({
      next: (users) => {
        this.allUsers = users;
        console.log(users);
        this.totalItems = this.allUsers.length;
        this.applyPagination();
        this.isLoading = false;
        
        console.log(`Loaded ${this.totalItems} users total`);
      },
      error: (err) => {
        console.error('Error loading all users:', err);
        this.isLoading = false;
        this.allUsers = [];
        this.users = [];
        this.totalItems = 0;
        this.totalPages = 0;
      }
    });
  }
onUserTypeChange() {
  this.currentPage = 1;
  this.loadAllUsers();
}
  // تطبيق الـ pagination يدوياً
  applyPagination() {
    let dataToPaginate = this.allUsers;

    // تطبيق البحث إذا كان موجود
    if (this.searchTerm) {
      const term = this.searchTerm.toLowerCase();
      dataToPaginate = this.allUsers.filter(user =>
        user.name?.toLowerCase().includes(term) ||
        user.email?.toLowerCase().includes(term) ||
        user.phone?.toLowerCase().includes(term)
      );
    }

    this.totalItems = dataToPaginate.length;
    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);

    // تأكد أن الصفحة الحالية ضمن النطاق الصحيح
    if (this.currentPage > this.totalPages) {
      this.currentPage = this.totalPages || 1;
    }

    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    
    this.users = dataToPaginate.slice(startIndex, endIndex);
    this.filteredUsers = [...this.users];

    console.log(`Page ${this.currentPage}: Showing ${this.users.length} of ${this.totalItems} users`);
  }

  loadPage(page: number) {
    if (this.isLoading) return;

    this.currentPage = page;
    this.applyPagination();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  goToPage(page: number) {
    console.log(`Going to page: ${page}`);
    if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
      this.loadPage(page);
    } else {
      console.log(`Invalid page: ${page}, Current: ${this.currentPage}, Total: ${this.totalPages}`);
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.goToPage(this.currentPage - 1);
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.goToPage(this.currentPage + 1);
    }
  }

  getPageNumbers(): number[] {
    const pages: number[] = [];
    const maxVisiblePages = 5;
    
    if (this.totalPages <= 1) {
      return [1];
    }
    
    let startPage = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(this.totalPages, startPage + maxVisiblePages - 1);
    
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  }

  onItemsPerPageChange(event: any) {
    const newItemsPerPage = parseInt(event.target.value, 10);
    if (newItemsPerPage !== this.itemsPerPage && newItemsPerPage > 0) {
      this.itemsPerPage = newItemsPerPage;
      this.currentPage = 1;
      console.log(`Changing items per page to: ${this.itemsPerPage}`);
      this.applyPagination();
    }
  }

  getStartIndex(): number {
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  getEndIndex(): number {
    const end = this.currentPage * this.itemsPerPage;
    return Math.min(end, this.totalItems);
  }

  onSearch(event: any) {
    this.searchTerm = event.target.value.trim();
    this.currentPage = 1;
    this.applyPagination();
  }

  handleImageError(event: any) {
    event.target.src = 'assets/images/logo/logo.svg';
  }

  editUser(user: any) {
    this.router.navigate(['/admin/edit-user', user.id]);
  }

  deleteUser(user: any) {
    if (!user) return;

    const message = `🗑️ Are you sure you want to delete user "${user.name}"?\nThis action cannot be undone.`;
    const confirmed = confirm(message);
    
    if (!confirmed) return;

    this.userService.deleteUser(user.id).subscribe({
    next: (res) => {
      alert(res.message || 'تم حذف المستخدم بنجاح');
      this.loadAllUsers();
    },
    error: (err) => {
      console.error(err);
      alert(err.error?.message || 'حدث خطأ أثناء حذف المستخدم');
    }
  });
  }


viewDetails(user: any) {  
  const loginPayload: loginByAdmin = {
    email: user.email ?? user.phone,  // e.g., "admin@gmail.com"
    login_by: 'email',  // or 'phone' based on logic
    user_type: user.type  // optional: 'customer' or 'admin'
  };
  this.userService.loginUserByAdmin(loginPayload).subscribe({
    next: (res) => { console.log(res); 
      if (res.access_token) {
    // بعت التوكن في fragment (مش بيظهر في URL history)
    // const url = `https://true-ecommerce.web.app?Admin-authorization-token=${encodeURIComponent(res.access_token)}`;
    let url = this.userUrl;
    if (this.userUrl == '') {
       url = this.domain;
    } else {
      url = this.userUrl;
    }
    url += `?Admin-authorization-token=${encodeURIComponent(res.access_token)}`;
    console.log(url);
const width = 1200;
const height = 800;

const left = window.screenX + (window.outerWidth - width) / 2;
const top = window.screenY + (window.outerHeight - height) / 2;

window.open(
  url,
  'CustomerWindow',
  `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
);  }
    }
  });
}


LoginUserByAdmin(phone:string , name : string) {  
  const loginPayload: loginByAdmin = {
    email: phone,  // e.g., "admin@gmail.com"
    login_by: 'phone',  // or 'phone' based on logic
    user_type: "customer",  // optional: 'customer' or 'admin'
    name : name
  };
  this.userService.loginUserByAdmin(loginPayload).subscribe({
    next: (res) => { console.log(res); 
      if (res.access_token) {
    // بعت التوكن في fragment (مش بيظهر في URL history)
    const url = `${this.domain}?Admin-authorization-token=${encodeURIComponent(res.access_token)}`;
    console.log(url);
    window.open(url, '_blank');
  }
    }
  });

  
}
isModalOpen = false;
userName = '';
phoneNumber = '';

openModal() {
  this.isModalOpen = true;
}

closeModal() {
  this.isModalOpen = false;
}

submit(form : any) {
  if (form.invalid) return;

  console.log(this.userName, this.phoneNumber);
  this.LoginUserByAdmin(this.phoneNumber,this.userName);
  this.closeModal();
}


  addUser() {
    this.router.navigateByUrl('/admin/add-user');
  }

  toggleBanned(user: any) {
    // this.userService.updateUser(user.id, { banned: !user.banned })
    //   .subscribe({
    //     next: (res) => {
    //       user.banned = !user.banned;
    //       console.log('✅ Banned status updated');
    //     },
    //     error: (err) => {
    //       console.error('❌ Error updating banned status:', err);
    //       alert('⚠️ Failed to update banned status');
    //     }
    //   });
  }

  toggleStatus(user: any) {
    this.userService.updateUserFlags(user.id, { status: !user.status })
      .subscribe({
        next: (res) => {
          user.status = !user.status;
          console.log('✅ Status updated');
        },
        error: (err) => {
          console.error('❌ Error updating status:', err);
          alert('⚠️ Failed to update status');
        }
      });
  }

  getUserType(type: string): string {
    const userType = this.userTypes.find(t => t.value === type);
    return userType ? userType.label : 'Unknown';
  }

  getTypeClass(type: string): string {
    const userType = this.userTypes.find(t => t.value === type);
    return userType ? userType.class : 'unknown';
  }

  getLoadingInfo(): string {
    return `Page ${this.currentPage} of ${this.totalPages} (${this.totalItems} total users)`;
  }
}